'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'search-clear',
    /* eslint-disable max-len */
    shape: _react2.default.createElement('path', { d: 'M12.414 11l2.392-2.392a.5.5 0 0 0 0-.707l-.707-.707a.5.5 0 0 0-.707 0L11 9.586l-2.39-2.39a.5.5 0 0 0-.707 0l-.707.707a.5.5 0 0 0 0 .707L9.586 11l-2.39 2.39a.5.5 0 0 0 0 .707l.707.707a.5.5 0 0 0 .707 0l2.39-2.39 2.392 2.392a.5.5 0 0 0 .707 0l.707-.707a.5.5 0 0 0 0-.707L12.414 11zM11 20a9 9 0 1 1 0-18 9 9 0 0 1 0 18z' }),
    /* eslint-enable max-len */
    viewbox: '0 0 22 22',
    label: 'search-clear'
};
//# sourceMappingURL=search-clear.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/lib/cjs/svg/search-clear.js
 ** module id = 474
 ** module chunks = 1
 **/